var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var REGIONS_ENDPOINTS = {
    ALL: "/Regions"
};
/**
 * RegionsApiClient - client for fetching regions from BFF
 * @exports
 * @class RegionsApiClient
 * @extends BaseApiClient
 */
var RegionsApiClient = /** @class */ (function (_super) {
    __extends(RegionsApiClient, _super);
    function RegionsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all regions from BFF
     * @throws {RequiredError}
     * @memberof RegionsApiClient
     */
    RegionsApiClient.prototype.getRegions = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(REGIONS_ENDPOINTS.ALL, fetchOptions);
    };
    return RegionsApiClient;
}(BaseApiClient));
export { RegionsApiClient };
//# sourceMappingURL=RegionsApiClient.js.map